type DynamicYieldRecommendationContext = { type: 'HOMEPAGE' } | { type: 'OTHER'; data: never[] };

function normalizePath(path: string) {
  const pathWithoutQuery = path.split(/[?#]/, 1)[0];
  const pathWithoutLocale = pathWithoutQuery.replace(/^\/en-(?:us|gb|ca|au)(?=\/|$)/i, '');
  return pathWithoutLocale.replace(/\/+$/, '') || '/';
}

function getRecommendationContext(path: string): DynamicYieldRecommendationContext {
  return normalizePath(path) === '/' ? { type: 'HOMEPAGE' } : { type: 'OTHER', data: [] };
}

export function setDynamicYieldRecommendationContext(path: string) {
  if (typeof window === 'undefined') return;

  const dy = (window as any).DY || {};
  (window as any).DY = dy;
  const nextContext = getRecommendationContext(path);
  const currentContext = dy.recommendationContext;
  const isSameContext =
    currentContext?.type === nextContext.type &&
    (nextContext.type === 'HOMEPAGE' ||
      (Array.isArray(currentContext?.data) && currentContext.data.length === nextContext.data.length));

  if (!isSameContext) dy.recommendationContext = nextContext;
}
